/**
 * Returns a urlencoded form body string from a
 * an array of params. This would be suitable
 * to pass as a fetch POST body when using
 * a application/x-www-form-urlencoded content type
 *
 * @param params key/value pairs to be used
 */
export function getUrlEncodedFormBody(params: { [key: string]: string }) {
  return Object.keys(params)
    .map(k => {
      return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
    })
    .join('&');
}



// WEBPACK FOOTER //
// ./src/utils/fetch.ts